"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentService = {
    getLastTransaction: function (paymentInfo) {
        var _a;
        return (_a = paymentInfo) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, current) {
            return acc.transactionTime > current.transactionTime ? acc : current;
        }, {});
    },
};
